const DEFAULT_FUNCTION_NOT_EXIST_TEXT = 'You tried to call an undefined function'

export const callFunctionIfDefined = (func, params, errorMessage) => {
  if (typeof func === 'function') {
    func(...params)
  } else {
    console.error(errorMessage ?? DEFAULT_FUNCTION_NOT_EXIST_TEXT)
  }
}
